import { IModel } from "@/@types/models/model";
import { commonFields } from "./helpers/commonFields";

const Zgrada: IModel = {
  title: "Zgrade",
  apiPath: "operations/projekti/{projekt_id}/zgrade/{objekt_id}",
  forms : {
    "default": {
      fields: ["id", "opis_uporabe", "kategorija_uporabe", "ko_ime"]
    }
  },
  listViews: {
    "default": {
      fields: ["id", "opis_uporabe", "kategorija_uporabe", "ko_ime", "povrsina"]
    }
   
  },
  fields: [
    {
      title: "ID Zgrade",
      source: "id",
      ttoken: "common.id",
      type: "numeric",
      readonly: true
    },
    {
      title: "Ime KO",
      source: "ko_ime",
      ttoken: "dkp.zgrade.katastarska_opcina",
      type: "text",
      readonly: true
    },
    {
      title: "Opis Uporabe",
      source: "opis_uporabe",
      ttoken: "dkp.zgrade.opis_uporabe",
      type: "text",
      readonly: true,
    },
    {
      title: "Kategorija Uporabe",
      source: "kategorija_uporabe",
      ttoken: "dkp.zgrade.kategorija_uporabe",
      type: "text",
      readonly: true,
    },
    {
      title: "Povrsina",
      source: "povrsina",
      ttoken: "dkp.zgrade.povrsina",
      type: "numeric",
      readonly: true
    },
    commonFields.wkt
  ]
}

export default Zgrada;
